module.exports = __webpack_public_path__ + "static/img/bg_phone_new.951c48c9.webp";